import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';

import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import TextareaAutosize from '@mui/material/TextareaAutosize';
import { requestTrello } from '../actions/requestAction';
import { Component } from 'react';
import { connect } from "react-redux";
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';

import CloseIcon from '@mui/icons-material/Close';
import { messageLogin } from "../actions/loginUser";
import { Select, MenuItem, Chip } from '@mui/material';
import { formatBold, formatDate} from './util/utils';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import frLocale from 'date-fns/locale/fr';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

class NewProspectForm extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      // Form fields
      entreprise: "",        // Nom de l’entreprise
      gerant: "",         // gérant
      street: "",          // adresse
      comp: "",            // complément
      cp: "",                // code postal
      city: "",              // ville
      mail: "",              // Adresse mail
      tel: "",               // Téléphone
      secteur: "",           // Secteur envisagé
      activities: [],        // Domaine d'activité
      reseau: "",            // Réseau
      enseigne: "",
      expo: "Non",           // Expo
      nb_places: "",         // Nombre de places
      cinerary: "",          // Part de cinéraires
      motif: "Non",          // Motifs/gravures
      fournisseurs: "",      // Fournisseurs
      concurrence: "",       // Concurrence
      prestataire: "",       // Prestataire web
      creationDate: null,      // Date de creation
      nb_deaths: "",         // Nombre de décès
      nb_monuments: "",      // Nombre de monuments 
      nb_convoys: "",        // Nombre de convois
      divers: "",            // Divers
      request_attachment: null, // File input
      
      // UI 
      send_valid: false,     // Validation flag
      open_alert: false,     // Show/hide alert
      btn_text: "Envoyer la demande", // Button text
      btn_disabled: false,   // Disable submit button
      text_changed: false,    // Tracks if the form has changed (for loading gif)
      mailValid: true,
      telValid: true,
      button_clicked: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  removeFile() {
    this.setState({ request_attachment: null });
    if (this.fileInput) {
      this.fileInput.value = "";
    }
  }

  componentDidMount() {
    // if(this.props.client){
    //   const clientSelected=this.props.client;
    //   this.setState({ client: clientSelected })
    // }
  }
  componentWillReceiveProps(nextProps) {
    // this.setState({ client: nextProps.client })
  }
  componentDidUpdate(prevProps, prevState) {
    if ((this.props.message_error || this.state.notValid) && this.state.button_clicked) {
      if (this.formRef.current) {
        this.setState({button_clicked: false, notValid: false})
        this.formRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }


  handleChange(e) {
    if (e.target.name !== 'request_attachment') {
      this.setState({
        [e.target.name]: e.target.value,
      })
      if (e.target.name === "mail") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.setState({ mailValid: emailRegex.test(e.target.value) });
      }
      if (e.target.name === "tel") {
        const telRegex = /^\+?\d{10,15}$/;
        this.setState({ telValid: telRegex.test(e.target.value) });
      }
    }
    else {
      const file = e.target.files[0];
      if (file) {
        this.setState({
          request_attachment: file
        })
      }
    }
  }

  handleChangeSelect = (event) => {
    const { value } = event.target;
    this.setState({
      activities: typeof value === 'string' ? value.split(',') : value,
    });
  };

  handleSubmit(e) {
    const {
      entreprise,  gerant, street, comp, cp, city , mail, tel, secteur, activities, reseau, enseigne, expo, motif, fournisseurs,
      concurrence, prestataire, creationDate, nb_deaths, nb_monuments, nb_convoys, divers, request_attachment,cinerary, nb_places,
      mailValid, telValid
    } = this.state;
    const type = "newProspect"
    const creationDateFormatted = formatDate(creationDate)

    e.preventDefault();

    if (gerant !== "" && entreprise !== "") {

      if (mail !== "" && !mailValid) {
        this.setState({
          send_valid: true,
          notValid: true,
          button_clicked: true,
        });
        return
      }
      if (tel !== "" && !telValid) {
        this.setState({
          send_valid: true,
          notValid: true,
          button_clicked: true,
        });
        return
      }
      const separator = cp && city ? ", " : ""
    
      const title = "[INTRANET] " + "Nouveau prospect" + ' - ' + entreprise;
      const descriptionParts = [];
      descriptionParts.push(`Nom de l'entreprise : ${formatBold(entreprise)}`);
      descriptionParts.push(`Nom et Prénom du gérant : ${formatBold(gerant)}`);
      descriptionParts.push(`Adresse postale : `);
      descriptionParts.push(`${formatBold(street)}`);
      if (comp) descriptionParts.push(`${formatBold(comp)}`);
      if (cp || city) descriptionParts.push(`${formatBold(cp)}${separator}${formatBold(city)}`);
      descriptionParts.push(`Adresse mail : ${formatBold(mail)}`);
      descriptionParts.push(`Téléphone : ${formatBold(tel)}`);
      descriptionParts.push(`Secteur envisagé : ${formatBold(secteur)}`);
      descriptionParts.push(`Domaine d'activité : ${formatBold(activities)}`);
      descriptionParts.push(`Rattaché au réseau : ${formatBold(reseau)}`);
      descriptionParts.push(`Enseigne : ${formatBold(enseigne)}`);

      descriptionParts.push('');
      descriptionParts.push('---');
      descriptionParts.push('');

      descriptionParts.push(`Expo : ${formatBold(expo)}`);
      if (expo && expo === "Oui") descriptionParts.push(` - Nombre de places : ${formatBold(nb_places)}`);
      descriptionParts.push(` - Part de cinéraires : ${formatBold(cinerary)}`);
      descriptionParts.push('');
      descriptionParts.push(`Font-ils leurs motifs/gravures eux-mêmes : ${formatBold(motif)}`);

      descriptionParts.push('');
      descriptionParts.push('---');
      descriptionParts.push('');

      descriptionParts.push(`Autres fournisseurs : ${formatBold(fournisseurs)}`);
      descriptionParts.push(`Concurrence proche : ${formatBold(concurrence)}`);
      descriptionParts.push(`Prestataire web : ${formatBold(prestataire)}`);

      descriptionParts.push('');
      descriptionParts.push('---');
      descriptionParts.push('');

      descriptionParts.push(`Date de création : ${formatBold(creationDateFormatted)}`);
      descriptionParts.push(`Nombre de décès /an : ${formatBold(nb_deaths)}`);
      descriptionParts.push(`Nombre de monuments /an : ${formatBold(nb_monuments)}`);
      descriptionParts.push(`Nombre de convois /an : ${formatBold(nb_convoys)}`);

      descriptionParts.push('');
      descriptionParts.push('---');
      descriptionParts.push('');

      descriptionParts.push('Divers : ');
      descriptionParts.push(`${formatBold(divers)}`);

      // Join all parts with line breaks
      const description = descriptionParts.join('\n');
      // Add to FormData
      const formData = new FormData();
      formData.append('name', title.trim());
      formData.append('description', description);
      formData.append('type_request', type)
      formData.append('user', "")

      // Append file if it exists
      if (request_attachment) {
        const res = []
        res.push(request_attachment)
        formData.append('attachments[]', request_attachment);
      }
      this.props.requestTrello(formData);
      this.setState({
        btn_disabled: true,
        btn_text: "en cours...",
        text_changed: true
      });
    } else {
        this.setState({
          notValid: true,
        });
      
    }
    this.setState({
      send_valid: true,
      button_clicked: true,
    });
  }

  render() {
    const options = [
      'Pompes funèbres',
      'Marbriers',
      'Ambulanciers',
      'Thanato',
      'Autre',
    ];
    let open_alert = this.state.open_alert
    let btn_text = this.state.btn_text
    let text_changed = this.state.text_changed
    let valid_button = this.state.btn_disabled
    if (this.props.message_error && this.state.send_valid) {
      open_alert = true;
      btn_text = "Envoyer la demande";
      text_changed = false;
      valid_button = false;
    }
    
  
    return (
      <div className="div-app">
        <div className="monumentForm" style={{ textAlign: "center" }} ref={this.formRef}>
          <Box component="form" noValidate autoComplete="off" sx={{ minWidth: 120 }}>
            <h3>Nouveau prospect</h3>
            <Collapse in={open_alert}>
              <Alert severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      this.setState({
                        open_alert: false, btn_text: "Envoyer la demande",
                        text_changed: false, btn_disabled: false, btn_text: "Envoyer la demande",
                        text_changed: false, btn_disabled: false
                      });
                      this.props.messageLogin();
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                Une erreur s'est produite, veuillez réessayer ultérieurement.
              </Alert>
            </Collapse>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id={this.state.send_valid &&
              this.state.entreprise === "" ? "field_error" : ""}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Nom de l’entreprise*
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="entreprise" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.entreprise} />
              {this.state.send_valid && this.state.entreprise === "" &&
                <span className="text-error">*Nom de l'entreprise est obligatoire</span>
              }
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id={this.state.send_valid &&
              this.state.gerant === "" ? "field_error" : ""}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Nom et Prénom du gérant*
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="gerant" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.gerant} />
              {this.state.send_valid && this.state.gerant === "" &&
                <span className="text-error">*Nom et Prénom du gérant est obligatoire</span>
              }
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Adresse postale
              </InputLabel><br />
              <input type="text" className="inputForm title address" placeholder="N° et nom de la rue" name="street" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.street} />

              <input type="text" className="inputForm title address" placeholder="Complément" name="comp" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.comp} />
              <div className="cp-city">
                <input type="text" className="inputForm title" placeholder="Code postal" name="cp" onFocus={() => {
                  this.setState({
                    send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                    text_changed: false, btn_disabled: false
                  });
                  this.props.messageLogin();
                }}
                  onChange={this.handleChange} value={this.state.cp} />

                <input type="text" className="inputForm title" placeholder="Ville" name="city" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.city} />
              </div>
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id={this.state.send_valid &&
              this.state.mail !== "" && !this.state.mailValid ? "field_error" : ""} >
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Adresse mail
              </InputLabel><br />
              <input type="email" className="inputForm title" placeholder="" name="mail" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.mail} />
                {this.state.send_valid && this.state.mail !== "" && !this.state.mailValid &&
                <span className="text-error">Adresse mail invalide</span>
              }
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id={this.state.send_valid &&
              this.state.tel !== "" && !this.state.telValid ? "field_error" : ""}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Téléphone
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="tel"  onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.tel} />
                {this.state.send_valid && this.state.tel !== "" && !this.state.telValid &&
                <span className="text-error">Téléphone invalide</span>
              }
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Secteur envisagé
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="Ouest, Midi, Nord.." name="secteur" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.secteur} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Domaine d'activité
              </InputLabel><br />
              <Select
                  labelId="services-select-label"
                  multiple
                  value={this.state.activities}
                  onChange={this.handleChangeSelect}
                  displayEmpty
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em class="select">Sélectionner un ou plusieurs</em>; // placeholder
                    }
                    return (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    );
                  }}
                >
                  {options.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
              </Select>
              </FormControl>
            
            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Rattaché à un réseau ?
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="reseau" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.reseau} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Enseigne ?
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="enseigne" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.enseigne} />
            </FormControl>

            <div className="line"></div>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id={this.state.send_valid &&
              this.state.expo === "" ? "field_error" : ""}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Expo
              </InputLabel><br />
              <div style={{textAlign:"initial", paddingLeft:"0.5rem", marginTop:"0.5rem"}}>
              <label id= "labelRadio">
                <input
                  type="radio"
                  name="expo"
                  value="Oui"
                  checked={this.state.expo === "Oui"}
                  onChange={this.handleChange}
                />
                Oui
              </label>

              <label style={{ marginLeft: "1rem" }} id= "labelRadio">
                <input
                  type="radio"
                  name="expo"
                  value="Non"
                  checked={this.state.expo === "Non"}
                  onChange={this.handleChange}
                />
                Non
              </label>
              </div>
              <div style={{textAlign:"initial", paddingLeft:"0.5rem",marginTop:"0.5rem"}}>
                {this.state.expo === "Oui" && <>
                  <label id= "labelRadio">Combien de places</label>
                  <input type="number" className="inputForm title" placeholder="" name="nb_places" onFocus={() => {
                    this.setState({
                      send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                      text_changed: false, btn_disabled: false
                    });
                    this.props.messageLogin();
                  }}
                    onChange={this.handleChange} value={this.state.nb_places} />
                </>}
                <label id= "labelRadio">Part de cinéraires</label>
                <input type="text" className="inputForm title" placeholder="" name="cinerary" onFocus={() => {
                  this.setState({
                    send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                    text_changed: false, btn_disabled: false
                  });
                  this.props.messageLogin();
                }}
                  onChange={this.handleChange} value={this.state.cinerary} />
              </div>
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id={this.state.send_valid &&
              this.state.motif === "" ? "field_error" : ""}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Font-ils leurs motifs/gravures eux-mêmes
              </InputLabel><br />
              <div style={{textAlign:"initial", paddingLeft:"0.5rem", marginTop:"0.5rem"}}>
                <label id= "labelRadio">
                  <input
                    type="radio"
                    name="motif"
                    value="Oui"
                    checked={this.state.motif === "Oui"}
                    onChange={this.handleChange}
                  />
                  Oui
                </label>

                <label id= "labelRadio" style={{ marginLeft: "1rem" }}>
                  <input
                    type="radio"
                    name="motif"
                    value="Non"
                    checked={this.state.motif === "Non"}
                    onChange={this.handleChange}
                  />
                  Non
                </label>
              </div>
            </FormControl>

            <div className="line"></div>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Autres fournisseurs ?
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="fournisseurs" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.fournisseurs} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Concurrence proche ?
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="concurrence" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.concurrence} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Prestataire web ?
              </InputLabel><br />
              <input type="text" className="inputForm title" placeholder="" name="prestataire" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.prestataire} />
            </FormControl>

            <div className="line"></div>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Date de création
              </InputLabel><br />
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
                <DatePicker
                  label=""
                  inputFormat="dd/MM/yyyy"
                  mask="__/__/____"
                  value={this.state.creationDate}
                  onChange={(newValue) => {
                    this.setState({ creationDate: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        placeholder: "jj/mm/aaaa"
                      }}
                      InputProps={params.InputProps}
                      sx={{
                        "& .MuiIconButton-root": {
                          marginRight: 0
                        }
                      }}
                      onFocus={() => {
                        this.setState({
                          send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                          text_changed: false, btn_disabled: false
                        });
                        this.props.messageLogin();
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Nombre de décès /an
              </InputLabel><br />
              <input type="number" className="inputForm title" placeholder="" name="nb_deaths" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.nb_deaths} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Nombre de monuments /an 
              </InputLabel><br />
              <input type="number" className="inputForm title" placeholder="" name="nb_monuments" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.nb_monuments} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2"  >
                Nombre de convois /an
              </InputLabel><br />
              <input type="number" className="inputForm title" placeholder="" name="nb_convoys" onFocus={() => {
                this.setState({
                  send_valid: false, open_alert: false, btn_text: "Envoyer la demande",
                  text_changed: false, btn_disabled: false
                });
                this.props.messageLogin();
              }}
                onChange={this.handleChange} value={this.state.nb_convoys} />
            </FormControl>

            <div className="line"></div>

            <FormControl fullWidth style={{ paddingBottom: "16px" }} id="">
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2" >
                Divers
              </InputLabel><br />
              <TextareaAutosize minRows={3} className="textareaForm" placeholder="Poseur ? Recette particulière ? Information importante ?"
                name="divers" onChange={this.handleChange} onFocus={() => {
                  this.setState({ send_valid: false, open_alert: false });
                  this.props.messageLogin();
                }}
                value={this.state.divers} />
            </FormControl>

            <FormControl fullWidth style={{ paddingBottom: "0" }}>
              <InputLabel variant="standard" htmlFor="uncontrolled-native" id="labelForm2">
               Carte de visite <span className="facultatif"></span>
              </InputLabel><br />
              <Button
                variant="outlined"
                component="label"
                id="button-secondary"
              >
                Joindre un Fichier
                <input
                  name="request_attachment"
                  id="file"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  hidden
                  onChange={this.handleChange}
                  ref={(input) => (this.fileInput = input)}
                />
              </Button>

              <div id="attachContainer" className="attachedFilesContainer">
                {this.state.request_attachment && (
                  <div className='attachedFile'>
                    <span className='attachedFileName'>{this.state.request_attachment.name}</span>
                    <Button onClick={() => this.removeFile()}>
                      <svg className='MuiSvgIcon-root attachedFileIcon MuiSvgIcon-fontSizeMedium MuiChip-deleteIcon MuiChip-deleteIconMedium MuiChip-deleteIconColorDefault MuiChip-deleteIconOutlinedColorDefault css-i4bv87-MuiSvgIcon-root' focusable='false' viewBox='0 0 24 24' aria-hidden='true' data-testid='CancelIcon'><path d='M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z'></path></svg>
                    </Button>
                  </div>
                )
                }
              </div>
            </FormControl>

            <FormControl fullWidth style={{ marginTop: "16px" }}>
              <Button variant="contained" id="button-primary" onClick={this.handleSubmit} disabled={valid_button}>
                {btn_text}
                {this.state.btn_disabled && text_changed && <img src={`${process.env.PUBLIC_URL}/style/reload.gif`} style={{ width: "100px" }} />}
              </Button>
              <br/>
            </FormControl>
          </Box>
        </div>

      </div>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    requestTrello: (formData) => dispatch(requestTrello(formData, ownProps)),
    messageLogin: () => dispatch(messageLogin()),
  };
};
const mapStateToProps = ({ eventGRC, usersReducer }) => {
  return {
    contacts: usersReducer.contacts,
    message_error: usersReducer.message_error,
    client : eventGRC.client
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(NewProspectForm);